'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.getPersonalOrderDetail = getPersonalOrderDetail;
exports.getPersonalOrderList = getPersonalOrderList;
exports.setOrder = setOrder;
exports.setPayOrder = setPayOrder;
exports.loadPage = loadPage;
exports.cancelOrder = cancelOrder;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPersonalOrderDetail(id) {
    return {
        types: [_constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_LOAD, _constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_SUCCESS, _constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getOrderById(id);
        }
    };
}

function getPersonalOrderList() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT;

    return {
        types: [_constants.Personal.OrderList.PERSONAL_ORDER_LIST_LOAD, _constants.Personal.OrderList.PERSONAL_ORDER_LIST_SUCCESS, _constants.Personal.OrderList.PERSONAL_ORDER_LIST_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getOrders(page - 1, limit).then(function (result) {
                if (result.orders.length === 0) {
                    return iBonus.getOrders(0, limit).then(function (result) {
                        return (0, _extends3.default)({}, result, {
                            activePage: 1,
                            limit: limit
                        });
                    });
                }
                return (0, _extends3.default)({}, result, {
                    limit: limit,
                    activePage: page
                });
            });
        }
    };
}

function setOrder(order_id) {
    var client_comment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var service_in_slug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var delivery_address = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return {
        types: [_constants.Personal.OrderList.ORDER_SETTING_SEND, _constants.Personal.OrderList.ORDER_SETTING_SUCCESS, _constants.Personal.OrderList.ORDER_SETTING_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.setOrder(order_id, client_comment, service_in_slug, delivery_address);
        }
    };
}

function setPayOrder(order_id) {
    var client_comment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var service_in_slug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var delivery_address = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var discount_sum = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var coupon_id = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var coupon_token = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    var customer_coupon_id = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    var custom_fields = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
    var child_orders = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
    var captcha = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;

    return {
        types: [_constants.Personal.OrderList.ORDER_SETTING_SEND, _constants.Personal.OrderList.ORDER_SETTING_SUCCESS, _constants.Personal.OrderList.ORDER_SET_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.setPayOrder(order_id, client_comment, service_in_slug, delivery_address, discount_sum, coupon_id, coupon_token, customer_coupon_id, custom_fields, child_orders, captcha);
        }
    };
}

function loadPage(location) {
    return {
        types: [_constants.Personal.OrderDetail.LOAD_PAGE, _constants.Personal.OrderDetail.LOAD_PAGE, _constants.Personal.OrderDetail.LOAD_PAGE],
        promise: function promise() {
            return new _promise2.default(function (resolve) {
                resolve({
                    show_404: location.pathname
                });
            });
        }
    };
}

function cancelOrder(order) {
    return {
        types: [_constants.Personal.OrderList.ORDER_SETTING_SEND, _constants.Personal.OrderList.ORDER_SETTING_SUCCESS, _constants.Personal.OrderList.ORDER_SETTING_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.cancelOrder(order.id);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/personal.js
// module id = 165
// module chunks = 0